// Quick-add input met eenmalige syntax-hint bij eerste focus.
import { Box } from '@mui/material';
import TaskInputQuick from '@/features/tasks/components/forms/TaskInputQuick';
import OnboardingHintCard from '@/features/onboarding/components/OnboardingHintCard';
import { onboardingHintCardFixedPositionSx } from '@/features/onboarding/utils/onboardingHintCardSx';
import { useQuickAddFocusHint } from '@/hooks/ui/use-quick-add-focus-hint';
import {
  isDesktopBreakpoint,
  useBreakpoint,
} from '@/hooks/ui/useBreakpoint';
import { useT } from '@/i18n/useT';

export default function QuickAddFieldWithHint({ sx }) {
  const t = useT();
  const breakpoint = useBreakpoint();
  const isDesktop = isDesktopBreakpoint(breakpoint);
  const {
    showHint,
    onQuickAddFocus,
    onQuickAddBlur,
    onQuickAddChange,
    dismissHint,
  } = useQuickAddFocusHint();

  const example = t('help.quickbar.example', 'Offerte nakijken #werk @kantoor ~30m');
  const shortcut = t('help.shortcuts.keys.quickAdd', 'n');
  const quickAddHintBody = t(
    'onboarding.quickAddHint.body',
    'Tip: typ bijvoorbeeld «{example}». Druk op {shortcut} om hier te typen. Dezelfde syntax werkt in de snel-toevoegbalk en bij inline bewerken. Meer onder Help.',
    { example, shortcut },
  );

  return (
    <Box sx={{ width: '100%' }}>
      <TaskInputQuick
        sx={sx}
        onInputFocus={onQuickAddFocus}
        onInputBlur={onQuickAddBlur}
        onInputChange={onQuickAddChange}
        onInputEscape={dismissHint}
      />
      {showHint && isDesktop ? (
        <OnboardingHintCard
          body={quickAddHintBody}
          testId="quick-add-focus-hint"
          positionSx={onboardingHintCardFixedPositionSx}
          onDismiss={dismissHint}
        />
      ) : null}
    </Box>
  );
}
